import classnames from 'classnames';
import * as React from 'react';
import './ViewContainer.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
}

const ViewContainer: React.SFC<Props> = ({className, children, ...rest}) => {
    return (
        <div className={classnames(className, 'container view')} {...rest}>
            {children}
        </div>
    );
};

export default ViewContainer;
